import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ProdutoPage } from '../produto/produto';
import { Cardapio } from '../../providers/cardapio';
import { LocalStorageProvider } from '../../providers/local-storage';
import lodash from 'lodash';

@Component({
  selector: 'page-cardapio-lista',
  templateUrl: 'cardapio-lista.html'
})

export class CardapioListaPage {

  categoria   : any
  items       : any = []
  loading     : boolean = false
  hasmore     : boolean = false
  defaultImage: any = "./assets/images/img-loading.png"

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public cardapioService: Cardapio,
    public storage: LocalStorageProvider,
    private localStorage: LocalStorageProvider
  ) {
    this.categoria = this.navParams.get('categoria');
  }

  ionViewDidLoad() {
    this.localStorage.storageGet('cardapio_produtos_' + this.categoria.produto_categoria_id).then(
      data => {
        if(data) {
          this.items = JSON.parse(data)
        } else {
          this.loading = true
        }
      }
    )

    this.cardapioService.refresh();
    this.cardapioService.cardapio(this.categoria.produto_categoria_id).then(
      data => {
        this.loading = false
        if (!lodash.isEqual(this.items, data)) {
          this.items = data
        }
        this.hasmore = this.cardapioService.checkHasmore();
      }
    )
  }

  doInfinite(infiniteScroll) {
    this.cardapioService.cardapio(this.categoria.produto_categoria_id).then(
      data => {
        this.items = data;
        infiniteScroll.complete();
        this.hasmore = this.cardapioService.checkHasmore();
      }
    )
  }

  doRefresh(refresher) {
    this.hasmore = true;
    this.cardapioService.refresh();
    this.cardapioService.cardapio(this.categoria.produto_categoria_id).then(
      data => {
        refresher.complete();
        this.items = data;
      }
    )
  }

  exibeProduto(item) {
    this.navCtrl.push(ProdutoPage, { produto: item, categoria: this.categoria });
  }

}



// WEBPACK FOOTER //
// ./src/pages/cardapio-lista/cardapio-lista.ts